import { parseCSSTransitionDuration } from 'app/lib/cssUtils';

const transitionDuration = '.2s';

export const leftMenuTransitionDuration =
  parseCSSTransitionDuration(transitionDuration);
